import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 20 20',
    fill: 'currentColor',
    defaultAriaLabel: 'Heart Icon',
};

export const HeartCviIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.0062 4.83751C10.9879 3.19604 12.8498 2.26597 14.7735 2.49209C17.1243 2.76842 18.9398 4.68859 19.084 7.05116L19.1038 7.37627C19.2311 9.46056 18.4512 11.4981 16.9649 12.9649C16.0534 13.8644 15.0554 14.672 13.9855 15.3759L10.3925 17.7397C10.1533 17.8971 9.84328 17.8964 9.60477 17.738L5.98643 15.3353C4.9671 14.6584 4.01287 13.8883 3.13603 13.0349C1.5865 11.5267 0.783 9.41058 0.940975 7.25402L0.960974 6.98101C1.1316 4.65179 2.93049 2.77096 5.24981 2.49684C7.1709 2.26978 9.02876 3.19981 10.0062 4.83751ZM5.41749 3.91553C3.77797 4.10931 2.50634 5.43886 2.38573 7.08538L2.36573 7.35839C2.23858 9.09412 2.88529 10.7973 4.13244 12.0111C4.94586 12.8029 5.83108 13.5173 6.7767 14.1452L10.0017 16.2868L13.2004 14.1824C14.1919 13.5301 15.1167 12.7817 15.9615 11.9481C17.1542 10.771 17.78 9.13591 17.6779 7.46331L17.6581 7.1382C17.556 5.46577 16.2708 4.1065 14.6067 3.9109C13.1515 3.73984 11.7462 4.50345 11.0979 5.8175L10.6405 6.74473C10.5196 6.98984 10.2694 7.14446 9.99606 7.14299C9.72275 7.14151 9.47424 6.9842 9.35596 6.7378L8.92798 5.84617C8.29069 4.5185 6.88001 3.74267 5.41749 3.91553Z"
            />
        </SvgIcon>
    );
};
